import api from './axios';

// DEVELOPMENT SERVER FALLBACK: Static data for when API fails
const FALLBACK_RESOURCES = {
  status: 'success',
  data: [
    {
      id: "fallback-1",
      s3Key: "public_resources/blog-articles/5 Ways AI is Revolutionizing Sales Conversations.md",
      title: "5 Ways AI is Revolutionizing Sales Conversations",
      description: "Comprehensive guide to implementing AI in your sales process",
      type: "blog article",
      author: "Velox AI Team",
      company: "",
      date: "2025-01-15T00:00:00.000Z",
      category: "Insights",
      industry: "",
      readTime: "5 min read",
      results: ""
    },
    {
      id: "fallback-2",
      s3Key: "public_resources/whitepapers/Building High-Performing Sales Teams- A Strategic Imperative for Sustainable Growth.md",
      title: "Building High-Performing Sales Teams: A Strategic Imperative for Sustainable Growth",
      description: "A comprehensive whitepaper on leveraging technology, especially AI, to build and empower high-performing sales teams for predictable revenue growth.",
      type: "whitepaper",
      author: "Velox AI Team",
      company: "",
      date: "2025-07-25T00:00:00.000Z",
      category: "Strategy",
      industry: "",
      readTime: "15 min read",
      results: ""
    }
  ]
};

export const resourcesService = {
  // Get public resources from S3
  getPublicResources: async (params = {}) => {
    try {
      // DEVELOPMENT SERVER FIX: Use different endpoint based on environment
      // Local development uses /static, development server uses /static-resources
      const isDevelopmentServer = window.location.hostname.includes('vercel.app') || 
                                 window.location.hostname.includes('velox-ai.com');
      
      const primaryEndpoint = isDevelopmentServer ? '/resources/static-resources' : '/resources/static';
      const fallbackEndpoint = isDevelopmentServer ? '/resources/static' : '/resources/static-resources';
      
      try {
        const response = await api.get(primaryEndpoint, { params });
        return response.data;
      } catch (primaryError) {
        console.warn('Primary endpoint failed, trying fallback:', primaryError.message);
        try {
          // Try fallback endpoint
          const response = await api.get(fallbackEndpoint, { params });
          return response.data;
        } catch (fallbackError) {
          console.warn('Both API endpoints failed, using client-side fallback:', fallbackError.message);
          // DEVELOPMENT SERVER FALLBACK: Return static data when all API calls fail
          return FALLBACK_RESOURCES;
        }
      }
    } catch (error) {
      console.error('Error fetching public resources, using fallback:', error);
      // Final fallback - return static data
      return FALLBACK_RESOURCES;
    }
  },

  // Get resource content for viewing
  getResourceContent: async (s3Key) => {
    try {
      const response = await api.get(`/resources/${encodeURIComponent(s3Key)}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching resource content:', error);
      throw error;
    }
  }
}; 